(ns nosco.images
  (:require [clojure.string :as string]))

(defn- split-on
  "Splits `s` at the first occurrence of `sep`, returning [before after] with
   `after` including the separator, or [s nil] when absent."
  [s sep]
  (if-let [i (string/index-of s sep)]
    [(subs s 0 i) (subs s i)]
    [s nil]))

(defn- with-size-param
  "Adds or replaces the `size` query param on a URL, preserving other params.

   Deliberately string-based rather than URL-parsing. These URLs come from
   stored rich-text content and from upload responses, and neither is
   guaranteed to be a well-formed, percent-encoded URL: filenames with spaces
   or a literal `%` are routine (see `nosco.pdfs.base`), and legacy content
   carries protocol-relative and `data:` srcs. A real parser rejects the first
   kind and mangles the second, so this stays total — anything that is not
   recognisably a query string is left untouched."
  [url size]
  (when url
    (let [[before-fragment fragment] (split-on url "#")
          [path query] (split-on before-fragment "?")
          params (->> (some-> query (subs 1) (string/split #"&"))
                      (remove string/blank?)
                      (remove #(string/starts-with? % "size="))
                      vec)
          new-query (string/join "&" (conj params (str "size=" size)))]
      (str path "?" new-query fragment))))

(defn thumbnail-url
  "Returns the thumbnail URL for an image URL."
  [image-url]
  (with-size-param image-url "thumbnail"))

(defn original-url
  "Returns the original URL for an image URL."
  [image-url]
  (with-size-param image-url "original"))
